export default async (value) => value === null
